import primitives from './themePrimitives'

const selectraThemeOverrides = {
  borders: {
    buttonBorderRadius: '.5rem',
    inputBorderRadius: '.5rem',
    radius100: '.24rem',
    radius200: '.5rem',
    radius300: '.75rem',
    radius400: '1rem',
  },
  colors: {
    // Primary brand color
    primary: primitives.primary, // Bleu Selectra #1460AA
    primaryA: primitives.primary,
    primary50: primitives.primary50,
    primary100: primitives.primary100,
    primary200: primitives.primary200,
    primary300: primitives.primary300,
    primary400: primitives.primary400,
    primary500: primitives.primary500,
    primary600: primitives.primary600,
    primary700: primitives.primary700,

    // Negative colors (errors)
    negative: primitives.negative,
    negative50: primitives.negative50,
    negative100: primitives.negative100,
    negative200: primitives.negative200,
    negative300: primitives.negative300,
    negative400: primitives.negative400,

    // Warning colors
    warning: primitives.warning,
    warning50: primitives.warning50,
    warning100: primitives.warning100,
    warning150: primitives.warning150,
    warning200: primitives.warning200,
    warning300: primitives.warning300,
    warning400: primitives.warning400,

    // Positive colors (success)
    positive: primitives.positive,
    positive50: primitives.positive50,
    positive100: primitives.positive100,
    positive200: primitives.positive200,
    positive300: primitives.positive300,
    positive400: primitives.positive400,

    // Content colors - texte reste noir
    contentPrimary: primitives.mono800, // Texte noir
    contentSecondary: primitives.mono600,
    contentTertiary: primitives.mono500,
    contentInversePrimary: primitives.white,
    contentInverseSecondary: primitives.mono200,
    contentInverseTertiary: primitives.mono300,

    // Border colors
    borderFocus: primitives.primary,
    borderSelected: primitives.primary,

    // Input colors
    inputFill: primitives.white,
    inputFillDisabled: primitives.mono100,
    inputFillActive: primitives.white,
    inputBorder: primitives.mono400, // Bordure plus foncée pour meilleure visibilité
    inputBorderDisabled: primitives.mono300,
    inputTextDisabled: primitives.mono500,
    inputEnhancerFill: primitives.primary,
    inputEnhancerFillDisabled: primitives.mono300,
    inputPlaceholder: primitives.mono500,
    inputPlaceholderDisabled: primitives.mono400,

    // Menu colors
    menuFill: primitives.white,
    menuFillHover: primitives.bg050,
    menuFontSelected: primitives.primary,
    menuFontHighlighted: primitives.primary,

    // Button colors
    buttonPrimaryFill: primitives.primary,
    buttonPrimaryText: primitives.white,
    buttonPrimaryHover: primitives.primary450,
    buttonPrimaryActive: primitives.primary500,

    buttonSecondaryFill: primitives.bg050,
    buttonSecondaryText: primitives.primary,
    buttonSecondaryHover: primitives.bg100,
    buttonSecondaryActive: primitives.bg150,
    buttonSecondaryBorder: primitives.mono400, // Bordure des boutons secondaires

    buttonTertiaryFill: primitives.white,
    buttonTertiaryText: primitives.primary,
    buttonTertiaryHover: primitives.bg050,
    buttonTertiaryActive: primitives.bg150,
    buttonTertiaryBorder: primitives.mono400, // Bordure des boutons tertiaires

    buttonMinimalFill: 'transparent',
    buttonMinimalText: primitives.primary,
    buttonMinimalHover: primitives.bg050,
    buttonMinimalActive: primitives.bg100,
    buttonMinimalBorder: primitives.mono400, // Bordure des boutons minimaux

    buttonDisabledFill: primitives.mono200,
    buttonDisabledText: primitives.mono500,
    buttonDisabledSpinnerBackground: primitives.mono400,

    // Table colors
    tableBackground: primitives.white,
    tableStripedBackground: primitives.bg050,
    tableHeadBackgroundColor: primitives.bg050,
    tableFilter: primitives.primary,
    tableBorder: primitives.mono300,

    // Table Grid colors (pour StyledHeadCell)
    contentStateDisabled: primitives.mono500,

    // Accordion colors
    accordionBackground: primitives.white,
    accordionBorder: primitives.mono300,
    accordionHeaderBackground: primitives.bg050,
    accordionHeaderBackgroundHover: primitives.bg100,
    accordionHeaderBackgroundExpanded: primitives.bg050,
    accordionHeaderText: primitives.primary,
    accordionContentBackground: primitives.white,

    // Background colors
    bg050: primitives.bg050, // Fond bleu très clair
    bg100: primitives.bg100,
    bg150: primitives.bg150,
    backgroundPrimary: primitives.white,
    backgroundSecondary: primitives.bg050,
    backgroundTertiary: primitives.bg100,

    // Mono colors (grays) for borders, disabled states
    mono100: primitives.mono100,
    mono200: primitives.mono200,
    mono300: primitives.mono300,
    mono400: primitives.mono400,
    mono500: primitives.mono500,
    mono600: primitives.mono600,
    mono700: primitives.mono700,
    mono800: primitives.mono800,
  },
  lighting: {
    shadow400: '0px 1px 3px rgba(0, 0, 17, 0.24)',
    shadow500: '0px 2px 6px rgba(0, 0, 17, 0.24)',
    shadow600: '0px 4px 12px rgba(0, 0, 17, 0.25)',
    shadow700: '0px 8px 24px rgba(0, 0, 17, 0.24)',
  },
  grid: {
    columns: [12, 12, 12],
    unit: 'rem',
    gutters: [1, 1, 1],
    margins: [0, 0, 0],
  },
  typography: {
    HeadingXSmall: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    HeadingSmall: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    HeadingMedium: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    HeadingLarge: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    HeadingXLarge: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    HeadingXXLarge: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    DisplayXSmall: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    DisplaySmall: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    DisplayMedium: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    DisplayLarge: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    DisplayXLarge: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    DisplayXXLarge: {
      fontWeight: 700,
      fontFamily: '"Trebuchet MS", sans-serif',
    },
    headingsFont: '"Trebuchet MS", sans-serif',
    bodyFont: 'Helvetica',
  },
}

export default selectraThemeOverrides
